import { faUserCircle } from '@fortawesome/pro-regular-svg-icons/faUserCircle';
import React from 'react';
import { getSignInUrl } from '../../constants/urls';
import useHasMounted from '../../hooks/useHasMounted';
import { useMemberData } from '../../redux/user/userHooks';
import { COLOR } from '../../styles/colors';
import Icon from '../../ui/Icon/Icon';
import Mugshot from '../Image/Mugshot';
import useSiteNavContext from './SiteNavContext';
import { SITE_NAV_MODE } from './SiteNavUtils';
import { StyledSignInButton, StyledSiteNavButton } from './StyledSiteNav';

const UserButton = () => {
  const { setNavMode } = useSiteNavContext();

  const hasMounted = useHasMounted();

  const memberData = useMemberData();

  const { photoUrl, name, isSignedIn } = memberData ?? {};

  const Component = isSignedIn ? StyledSiteNavButton : StyledSignInButton;

  const buttonProps = isSignedIn
    ? {
        onClick: () => setNavMode(SITE_NAV_MODE.UserMenu),
        children: photoUrl ? (
          // @ts-ignore
          <Mugshot src={photoUrl} alt={name} size={32} />
        ) : (
          <Icon icon={faUserCircle} color={COLOR.white} size={22} />
        )
      }
    : {
        href: getSignInUrl('react_signin_header', !hasMounted)
      };

  // @ts-ignore
  return <Component {...buttonProps}></Component>;
};

export default UserButton;
